
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class HhdzTable extends Vue {
    //红黑大战
    table = {
        data: [],
        column: [
            {
                key: 'red',
                title: '下注红金额',
                align: 'center',
                render: (h, params) => {
                    let strzo: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.red) {
                        if (JSON.parse(params.row.opt_detail).hits.hits.red.bet) {
                            strzo = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.red.bet)
                        }
                    }
                    return h('span', strzo)
                }
            },
            {
                key: 'black',
                title: '下注黑金额',
                align: 'center',
                render: (h, params) => {
                    let strzo: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.black) {
                        if (JSON.parse(params.row.opt_detail).hits.hits.black.bet) {
                            strzo = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.black.bet)
                        }
                    }
                    return h('span', strzo)
                }
            },
            {
                key: 'luck',
                title: '下注幸运一击金额',
                align: 'center',
                render: (h, params) => {
                    let strzo: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.luck) {
                        if (JSON.parse(params.row.opt_detail).hits.hits.luck.bet) {
                            strzo = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.luck.bet)
                        }
                    }
                    return h('span', strzo)
                }
            },
            {
                key: 'total_bet',
                title: '下注总投注金额',
                align: 'center',
                render: (h, params) => {
                    let strzo: any
                    if (JSON.parse(params.row.opt_detail).hits.total_bet) {
                        strzo = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.total_bet)
                    } else {
                        strzo = '/'
                    }
                    return h('span', strzo)
                }
            },
            {
                key: 'total_bet',
                title: '是否上庄',
                align: 'center',
                render: (h, params) => {
                    let str = JSON.parse(params.row.opt_detail).hits.is_banker ? '是' : '否'
                    return h('span', str)
                }
            },
            {
                key: 'b_dealer',
                title: '红方',
                align: 'center',
                render: (h, params) => {
                    let strzo = ''
                    let str = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        str = JSON.parse(params.row.opt_detail).award_content.point.red.poker
                    }
                    return h('div', [
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: str.map((x, index) => {
                                    return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'b_dealer',
                title: '黑方',
                align: 'center',
                render: (h, params) => {
                    let strzo = ''
                    let str = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        str = JSON.parse(params.row.opt_detail).award_content.point.black.poker
                    }
                    return h('div', [
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: str.map((x, index) => {
                                    return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'total_win',
                title: '变动金额',
                align: 'center',
                render: (h, params) => {
                    let str = (this as any).getMoney(params.row.chang_point)
                    let color = '#333'
                    if (str > 0) {
                        color = 'red'
                    } else if (str < 0) {
                        color = 'blue'
                    }
                    return h('span', { style: { color: color } }, str)
                }
            }
        ]
    }

    @Prop()
    listdata
}
